<!-- MainContainer.svelte -->
<script>
    const heroimage = './frog.png';
</script>

<style>
    .main-container {
        max-width: 800px;
        margin: 0 auto;
        padding: 20px;
        text-align: center;
    }

    .luckiest-guy-regular {
        font-family: "Bungee Tint", sans-serif;
        font-weight: 400;
        font-style: normal;
    }

    p {
        margin-bottom: 2rem;
        color: #555;
        text-align: left; /* Left-justifying the text by default */
    }

    .header-image {
        width: 100%;
        height: auto;
        border-radius: 8px;
        margin-bottom: 1.5rem;
    }

    .promo-text {
        margin-bottom: 2rem;
    }

    .highlight {
        color: black;
        background-color: yellow;
        font-weight: bold;
        padding: 2px 4px;
        border-radius: 3px;
    }

    .centered-text {
        text-align: center; /* Centering the text */
    }
</style>

<div class="main-container">
    <img src={heroimage} alt="Header Image" class="header-image">

    <h1 class="luckiest-guy-regular">Want to trade memecoins?</h1>

    <div class="promo-text">
        <p class="centered-text"><strong>Learn how with our PDF guide.</strong></p> 
        <p>Crypto is big - and confusing. You can't learn cryptography, and Bitcoin, and a bunch of other stuff and expect to master it all. You've got to focus.</p>
        <p>Memecoins are microcap projects on Solana, Ethereum and other chains that can skyrocket in value in a matter of days. The winners can do anything from 2x to 1000x. Pick right often enough and you can retire.</p>
        <p>We have a simple philosophy here at Memecoin Investor. We expect you want to learn how to trade memecoins, only memecoins. That's what we teach. No fluff, no padding, no hourlong podcasts to fill the time.</p>
        <p>Just lessons on how to find memecoins, how to avoid scams, when to buy and when to sell. Everything you need to profit.</p>
        <p>Sign up now to receive our free PDF guide on how to get started trading memecoins on Solana.</p>
    </div>
    <slot></slot>
</div>
